export default __webpack_public_path__ + "static/media/testi2.1c359519.jpg";